export default "__VITE_ASSET__BTuggcdw__"